import LongNameFormatter from "@src/@core/components/formatters/long-name-formatter";

export const decoColumns = (groupBy = []) => {
    const columns = [      
        {
            id      : "stage",
            name    : "Stage",
            width   : "250px",
            selector: row => row.stage,
            cell    : row => row.stage
        },
        {
            id      : "company_name",
            name    : "Company",
            selector: (row) => row.company_name,
            width   : "300px",
            cell    : (row) => {
                if (row["company_name"]) {
                    return row["company_name"] || "-";
                }
                return <LongNameFormatter
                    content={row.company_name}
                    className=""
                    id={`company-${row._id}`}
                    max={35}/>;
            },
            omit: !groupBy.includes("company_name")
        },
        {
            id      : "sdr",
            name    : "SDR",
            selector: row => row.sdr,
            cell    : row => row.sdr,
            omit    : !groupBy.includes("sdr")
        },
        {
            id      : "csm",
            name    : "CSM",
            selector: row => row.csm,
            cell    : row => row.csm,
            omit    : !groupBy.includes("csm")
        },
        {
            id      : "mrr",
            name    : "MRR",
            sortable: true,
            selector: row => row?.mrr ?? 0, 
            cell    : row => {
                const mrr = typeof row?.mrr === "number" ? row.mrr : parseFloat(row?.mrr?.props?.children) || 0;
                return `$${mrr.toLocaleString()}`;
            }
        }
    ];
    return columns;
};